import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { z } from "zod";
import SignedOut from "@/components/Organisms/SignedOut/SignedOut";
import { AUTH_LOGOUT_REASON_KEY } from "@/services/auth/auth.service";

// Define the logout reason schema
const logoutReasonSchema = z.enum(["inactivity", "session", "manual"]);
const signedOutSearchSchema = z.object({
	reason: logoutReasonSchema.optional(),
	hours: z.string().optional(), // For session expiry message
});

export const Route = createFileRoute("/signed-out")({
	component: RouteComponent,
	validateSearch: signedOutSearchSchema,
});

function RouteComponent() {
	const navigate = useNavigate();
	const { reason: reasonFromSearch, hours } = Route.useSearch();
	const [reason, setReason] = useState(reasonFromSearch);

	useEffect(() => {
		if (reasonFromSearch) {
			return;
		}
		const stored = sessionStorage.getItem(AUTH_LOGOUT_REASON_KEY);
		sessionStorage.removeItem(AUTH_LOGOUT_REASON_KEY);
		const parsed = logoutReasonSchema.safeParse(stored);
		if (parsed.success) {
			setReason(parsed.data);
		}
	}, [reasonFromSearch]);

	return (
		<div>
			<SignedOut
				reason={reason}
				sessionHours={hours ? Number.parseInt(hours, 10) : undefined}
				onSignIn={() => {
					navigate({ to: "/login", replace: true });
				}}
			/>
		</div>
	);
}
